module.exports = __webpack_public_path__ + "static/img/interest08.0dc6a61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/my-irish-date/interests_images/interest08.png
// module id = 9CU/
// module chunks = 0